import { Component, OnInit } from '@angular/core';
import { DatabaseService } from 'src/app/_services/database.service';
import { SnackBarOverview } from 'src/app/Toast';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-system-user-tabs',
  templateUrl: './system-user-tabs.component.html'
})
export class SystemUserTabsComponent implements OnInit {
  encrypt_id:any = '';
  sys_user_name:string = '';


  constructor(public db:DatabaseService,public router:Router,public toast: SnackBarOverview,public route:ActivatedRoute) { 
   
    this.route.params.subscribe(params=>{
      console.log(params);
      this.encrypt_id = params.id;
      console.log(this.encrypt_id);
    });
  }

  ngOnInit() {
    if(!this.encrypt_id)
    {
    this.encrypt_id = this.db.sys_user_id;
    }
    this.GetSystemUserDetail();
  }


  GetSystemUserDetail() {

    this.db.FetchData({'user_id': this.encrypt_id }, 'user/user_detail')
    .subscribe((result: any) => {
      console.log(result);
      this.sys_user_name = result['data']['detail']['name'];
      console.log(this.sys_user_name);
      
    }, error => {
      console.log(error);
      this.toast.openError('Something went wrong !!! Try again... ','');
    });
  }

}
